export enum BpsAdminPermissions
{
    Test = 4
}

// Synced with backend Shared.Domain.Enums.PermissionsEnum.UtilityPermissions
export enum UtilityPermissions
{
    AddNewUtilityUser = 10001,
    EditUtilityUser = 10002,
    DeleteUtilityUser = 10003,
    ViewUtilityUsers = 10004,
    ViewDashboard = 10005,
    ViewCustomerTable = 10006,
    ViewPostpaidTransactions = 10008,
    ViewPrepaidTransactions = 10009,
    ViewUtilitySettings = 10010,
    EditUtilitySettings = 10011,
    ViewAuditLogs = 10016,
    ViewStaffPage = 10018,
    ClaimServiceRequests = 10020,
    ViewStaffServiceRequestSteps = 10022,
    ViewSupervisorPage = 10024,
    ViewServiceRequestInstanceDetails = 10030,
    CreateDepartment = 10031,
    DeleteDepartment = 10032,
    EditDepartment = 10033,
    ViewDepartment = 10034,
    ViewBulkTransaction = 10038,
    ViewServiceRequestSupportDesk = 10039,
    CreateServiceRequestSupportDesk = 10041,
    CreateRole = 10042,
    EditRole = 10043,
    ViewRoles = 10044,
    DeleteRole = 10045,
    PublishUnpublishServiceRequestType = 10046,
    ViewWorkflowTable = 10047,
    CreateWorkflow = 10049,
    EditWorkflow = 10050,
    VerifyTransaction = 10051,
    UnassignStep = 10053,
    AssignStep = 10054,
    CreateServiceRequestDefinition = 10055,
    EditServiceRequestDefinition = 10056,
    ViewServiceRequestDefinition = 10057,
    AddBroadcastNotification = 10058,
    EditBroadcastNotification = 10059,
    DeleteBroadcastNotification = 10060,
    ViewBroadcastNotification = 10061,
    ViewServiceRequestDashboard = 10062,
    ViewReferral = 10065,
    AddStaffReferral = 10066,
    ViewReconcilliation = 10070,
    ViewRefunds = 10072,
    RetryRefund = 10073,
}

export enum ProviderPermissions
{
    Test = 20001
}

// Synced with backend Shared.Domain.Enums.PermissionsEnum.CustomerPermissions.
// Each backend entry carries module / subModule / action metadata (noted below);
// "View" is the default and is NOT required to open a page. The explicit View*
// permissions gate specific widgets/data, not whole pages.
export enum CustomerPermissions
{
    AddNewTeamMember = 30001,           // Settings / Account Management / Add
    EditAccountProfileDetails = 30002,  // Unknown (backend name has a typo: "Detaills")
    AddNewServiceRequest = 30003,       // Service Request Management / Service Request / Create
    ChatCustomerSupport = 30004,        // Support / Support / Chat
    ViewWallets = 30005,                // Unknown — widget-level gate
    ViewTransactionHistory = 30006,     // Unknown — widget-level gate
    ViewMeters = 30007,                 // Settings / Customer Energy Accounts / View — widget-level gate
    AddMeter = 30008,                   // Settings / Customer Energy Accounts / Add
    SetActiveMeter = 30009,             // Settings / Customer Energy Accounts / Set Active
    SetupAndEditEnergyAccount = 30010,  // Settings / Customer Energy Accounts / Edit
    UpdateEnergyAccountNin = 30011,     // Settings / Customer Energy Accounts / Update
    UnlinkMeter = 30012,                // Settings / Customer Energy Accounts / Unlink
}
